function getSelectedVariant(option1, option2, option3, product) {
  const optionsSelected = [option1, option2, option3]
    .filter(Boolean)
    .map(handleize)

  return product.variants.find(
    (variant) =>
      JSON.stringify(variant.options.map(handleize)) ===
      JSON.stringify(optionsSelected)
  )
}

function setUnavailableOptions(
  [option1, option2, option3],
  product,
  scoped_element
) {
  const variantTree = variantAvailabilityTree(product)
  //remove available classes before re-adding to options that are available
  scoped_element
    .querySelector('.product-variant-picker')
    ?.querySelectorAll('[data-option-1], [data-option-2], [data-option-3]')
    .forEach((element) => element.classList.remove('available'))

  for (const [level1Key, level1Values] of Object.entries(variantTree)) {
    const level1Keyhandleized = handleize(level1Key)

    scoped_element
      .querySelector(`[data-option-1="${level1Keyhandleized}"]`)
      ?.classList.toggle('available', level1Values.stock_available)

    if (level1Keyhandleized === option1) {
      for (const [level2Key, level2Values] of Object.entries(
        level1Values.options
      )) {
        const level2Keyhandleized = handleize(level2Key)
        scoped_element
          .querySelector(`[data-option-2="${level2Keyhandleized}"]`)
          ?.classList.toggle('available', level2Values.stock_available)

        if (level2Keyhandleized === option2) {
          for (const [level3Key, level3Values] of Object.entries(
            level2Values.options
          )) {
            const level3Keyhandleized = handleize(level3Key)
            scoped_element
              .querySelector(`[data-option-3="${level3Keyhandleized}"]`)
              ?.classList.toggle('available', level3Values.stock_available)
          }
        }
      }
    }
  }
}

//when a selected variant is sold out, the add to basket button is disabled
function toggleAddToBasketButton(productAvailable, scoped_element) {
  const addToBasketButton = scoped_element.querySelector('button.add-to-basket')
  if (!addToBasketButton) return

  addToBasketButton.querySelectorAll('.btn').forEach((button) => {
    button.hidden = true

    if (button.classList.contains('available') && productAvailable === true) {
      button.hidden = false
      addToBasketButton.disabled = false
    }

    if (
      button.classList.contains('unavailable') &&
      productAvailable === undefined
    ) {
      button.hidden = false
      addToBasketButton.disabled = true
    }

    if (button.classList.contains('soldout') && productAvailable === false) {
      button.hidden = false
      addToBasketButton.disabled = true
    }
  })
}

//when clicking a finish variant swatch, update the product carousel to show this image
function setProductCarouselToSelectedVariant(
  id,
  has_only_default_variant,
  product_carousel,
  scoped_element
) {
  if (!id || has_only_default_variant) return

  const variantImage = scoped_element.querySelector(
    `figure.product-carousel .swiper-slide.variant-primary-image[data-variant-id="${id}"]`
  )

  if (variantImage) {
    const indexToSlideTo = [...variantImage.parentNode.children].indexOf(
      variantImage
    )
    product_carousel.slideTo(indexToSlideTo)
  }
}

//when clicking an option, update the label to show the name of the selected item
function updateOptionLabels(option1, option2, option3, scoped_element) {
  const options = [option1, option2, option3]

  options.forEach((option, index) => {
    const optionLabel = scoped_element.querySelector(
      `.option span[data-option-index="${index + 1}"]`
    )
    //check for optionLabel as when variant picker is type:'dropdown' we don't update the label,
    if (option && optionLabel) {
      const nonHandleizedLabel = scoped_element.querySelector(
        `[data-option-${index + 1}="${option}"] span.non-handleized`
      )?.textContent

      optionLabel.innerHTML = nonHandleizedLabel
    }
  })
}

//update variant id in the url, required for sharing the url and updating the variant id field - used for adding the correct variant to the basket
function updateVariantId(id, section_product) {
  section_product.querySelector('.variant-id').value = id //note: when removing the hidden attribute, the value can be seen to update in the rendered input, for some reason it doesn't update in the devtools html viewer
  if (!section_product.closest('section#modal')) {
    const currentUrl = new URL(window.location.href)
    const params = currentUrl.searchParams
    params.set('variant', id)
    const newUrl = `${currentUrl.pathname}?${params.toString()}`
    window.history.replaceState({}, '', newUrl)
  }
}

//show correct variant price
function updatePrice(id, scoped_element) {
  scoped_element
    .querySelectorAll('.product-main .variant-prices .variant-price')
    .forEach((item) =>
      item.classList.toggle(
        'active',
        item.getAttribute('id') === `variant-price-${id}`
      )
    )
}

//show correct sku
function updateSku(id, scoped_element) {
  scoped_element
    .querySelectorAll('.product-main .variant-skus .variant-sku')
    .forEach((item) =>
      item.classList.toggle(
        'active',
        item.getAttribute('id') === `variant-sku-${id}`
      )
    )
}

//update stock level message
function updateStockLevelMessage(id, scoped_element) {
  scoped_element
    .querySelectorAll('.product-stock-messaging .variant-stock')
    .forEach((item) =>
      item.classList.toggle(
        'active',
        item.getAttribute('id') === `variant-stock-${id}`
      )
    )
}

function toggleImages(variantId, scoped_element) {
  scoped_element
    .querySelectorAll('.product-images-grid figure[data-variant-id]')
    .forEach((variant) => {
      const relevantVariantImageGroup =
        Number(variant.getAttribute('data-variant-id')) === variantId
      variant.classList.toggle('active', relevantVariantImageGroup)
    })

  //make first 3 visible elements 1/3 width
  let three_column_count = 3
  const activeImages = scoped_element.querySelectorAll(
    '.product-images-grid figure.active'
  )

  activeImages.forEach((figure) => {
    figure.classList.remove('span-4')

    if (activeImages.length === 1) {
      figure.classList.add('span-12')
      return
    }

    if (three_column_count > 0) {
      three_column_count = three_column_count - 1
      if (activeImages.length > 2) {
        figure.classList.add('span-4')
      }
    }
  })
}

//equivalent of shopify's handleize function
function handleize(string) {
  return string
    ?.toLowerCase() //Convert the string to lowercase
    .replace(/\./g, '-') //Replace dots with dashes
    .replace(/\s+/g, '-') //Replace spaces with dashes
    .replace(/[^\w\-]+/g, '') //Remove all non-word characters (except for dashes)
    .replace(/\-\-+/g, '-') //Replace multiple dashes with a single dash
    .replace(/^-+|-+$/g, '') //Trim dashes from the beginning and end of the string
}

function variantAvailabilityTree(product) {
  const variantTree = {}
  const optionValues = [new Set(), new Set(), new Set()]

  // Collect all unique values for each option level
  product.variants.forEach((variant) => {
    const [option1, option2, option3] = variant.options
    if (option1) optionValues[0].add(option1)
    if (option2) optionValues[1].add(option2)
    if (option3) optionValues[2].add(option3)
  })

  // Helper function to initialize each option level in the tree
  function ensureOptionLevel(tree, option) {
    if (!tree[option]) {
      tree[option] = {
        stock_available: false, // Start as false, update to true if any variant is available
        variant_combination_available: false,
        options: {}
      }
    }
    return tree[option]
  }

  // Populate tree with all possible options, defaulting to unavailable
  optionValues[0].forEach((option1) => {
    const level1 = ensureOptionLevel(variantTree, option1)
    optionValues[1].forEach((option2) => {
      const level2 = ensureOptionLevel(level1.options, option2)
      optionValues[2].forEach((option3) => {
        ensureOptionLevel(level2.options, option3)
      })
    })
  })

  // Update tree based on actual variants
  product.variants.forEach(
    ({ options: [option1, option2, option3], available }) => {
      const level1 = ensureOptionLevel(variantTree, option1)
      level1.variant_combination_available = true // Set to true since the combination exists
      if (available) level1.stock_available = true // Update availability based on stock status

      if (option2) {
        const level2 = ensureOptionLevel(level1.options, option2)
        level2.variant_combination_available = true
        if (available) level2.stock_available = true

        if (option3) {
          const level3 = ensureOptionLevel(level2.options, option3)
          level3.variant_combination_available = true
          if (available) level3.stock_available = true
        }
      }
    }
  )

  return variantTree
}

function initVariantPicker({
  section_product,
  selected_variant,
  has_only_default_variant,
  product,
  product_carousel
}) {
  if (!has_only_default_variant) {
    setUnavailableOptions(
      selected_variant.options.map(handleize),
      product,
      section_product
    )
  }
  toggleAddToBasketButton(selected_variant.available, section_product)
  toggleImages(selected_variant.id, section_product)

  //this is required to show/hide price and skus if the variant is unavailable
  //note 'unavailable' in this context does not mean 'sold out' - it means a combination of variant options isn't available as a product offering
  function showPriceAndSku(state) {
    section_product.querySelector('.variant-skus').hidden = !state
    section_product.querySelector('.variant-prices').hidden = !state
    //remove variantid query from url when variant doesnt exist
    if (!state) {
      const currentUrl = new URL(window.location.href)
      const params = currentUrl.searchParams
      params.delete('variant')
      const newUrl = `${currentUrl.pathname}?${params.toString()}`
      window.history.replaceState({}, '', newUrl)
    }
  }

  const productForm = section_product.querySelector(
    'form.product-form[action="/cart/add"]'
  )

  addReducedIndicatorToFirstOptions(product)
  updateReducedIndicator(product, selected_variant)

  productForm.addEventListener('change', function (event) {
    const form_values = Object.fromEntries(new FormData(this))
    const { option1, option2, option3 } = form_values

    const selectedVariant = !has_only_default_variant
      ? getSelectedVariant(option1, option2, option3, product)
      : product

    //some variant combinations aren't available, and so will be returned as 'undefined'
    const variantExists = selectedVariant !== undefined

    if (!has_only_default_variant) {
      setUnavailableOptions(
        [option1, option2, option3],
        product,
        section_product
      )
    }
    updateOptionLabels(option1, option2, option3, section_product)
    if (variantExists) {
      if (!has_only_default_variant) {
        updateVariantId(selectedVariant.id, section_product)
        updatePrice(selectedVariant.id, section_product)
        updateSku(selectedVariant.id, section_product)
        updateStockLevelMessage(selectedVariant.id, section_product)
        setProductCarouselToSelectedVariant(
          selectedVariant.id,
          has_only_default_variant,
          product_carousel,
          section_product
        )
      }
      toggleImages(selectedVariant.id, section_product)
      showPriceAndSku(true)
      toggleAddToBasketButton(selectedVariant.available, section_product)
      updateReducedIndicator(product, selectedVariant)
    } else {
      showPriceAndSku(false)
      toggleAddToBasketButton(undefined, section_product)

      //FIXME: temporary code to select the first available variant if the selection is changed to an unavailable combination
      if (!variantExists) {
        const clickedInput = event.target.closest('label.radio')
        if (!clickedInput.classList.contains('available')) return

        productForm.querySelectorAll('.option').forEach((option) => {
          let unavailableSelected = false
          option.querySelectorAll('label.radio').forEach((value) => {
            if (
              value.querySelector('input:checked') &&
              !value.classList.contains('available')
            ) {
              unavailableSelected = true
            }
          })
          if (unavailableSelected) {
            const firstAvailable = option.querySelector('label.radio.available')
            firstAvailable.click()
          }
        })
      }
    }
  })
}

function addReducedIndicatorToFirstOptions(product) {
  const variantPicker = document.querySelector('.product-variant-picker')

  product.variants.forEach(({ options, compare_at_price }) => {
    if (compare_at_price) {
      variantPicker
        .querySelector(`label[data-option-1="${handleize(options[0])}"]`)
        ?.classList.add('reduced')
    }
  })
}

function updateReducedIndicator(product, selectedVariant) {
  const variantPicker = document.querySelector('.product-variant-picker')
  if (!variantPicker) return

  variantPicker
    .querySelectorAll(
      `label[data-option-2].reduced, label[data-option-3].reduced`
    )
    .forEach((label) => label.classList.remove('reduced'))

  const selectedVariantOption1 = handleize(selectedVariant.options[0])
  const selectedVariantOption1Element = variantPicker.querySelector(
    `label[data-option-1="${selectedVariantOption1}"]`
  )

  if (!selectedVariantOption1Element?.classList.contains('reduced')) return

  product.variants.forEach(({ options, compare_at_price }) => {
    if (handleize(options[0]) === selectedVariantOption1 && compare_at_price) {
      variantPicker
        .querySelector(`label[data-option-2="${handleize(options[1])}"]`)
        ?.classList.add('reduced')
    }
  })

  const selectedVariantOption2 = handleize(selectedVariant.options[1])
  const selectedVariantOption2Element = variantPicker.querySelector(
    `label[data-option-2="${selectedVariantOption2}"]`
  )

  if (!selectedVariantOption2Element?.classList.contains('reduced')) return

  product.variants.forEach(({ options, compare_at_price }) => {
    if (handleize(options[1]) === selectedVariantOption2 && compare_at_price) {
      variantPicker
        .querySelector(`label[data-option-3="${handleize(options[2])}"]`)
        ?.classList.add('reduced')
    }
  })
}
